<template>

    <div class="container">
        <div class="row justify-content-center sb-my-health">
            <div class="col-md-7 mb-3">
                <h1 class="sb-main-header pt-2">My Benefits<span v-if="!list"> > {{healthplanD.plantypename}} </span></h1>
                <a v-if="!list" href="#" @click.prevent="handleBackToBenefitsClick" class="back-button">Back to Benefits</a>
            </div>
            <div class="col-md-3 mb-3 text-right">
                <a href="/my-health/personal-health-record" type="button" class="btn sb-btn-phr">
                    View my personal health record
                </a>
            </div>
            <div class="col-md-2 mb-3 text-right">
                <a href="#" onclick="bus.$emit('showHelp'); return false;" type="button" class="btn btn-danger sb-btn-help">
                    I need medical care
                </a>
            </div>
        </div>
        <div v-if="list" class="row">
<!--            <div class="" >-->
                <div class="card benefit-card col-md-4 " v-for="healthplan in healthplans">
                    <div class="card-body benefit-card-body"  :style="'border: 1px solid ' + getColor(healthplan.plantypename)">
                        <div class="row" :style="'border-bottom: 1px solid ' + getColor(healthplan.plantypename)">
                            <div class="col-sm-6 benefits_header" :style="'color: ' + getColor(healthplan.plantypename)">{{healthplan.plantypename}}</div>
<!--                            <div class="col-sm-7"><img :src="healthplan.carrier_logo" class="benefits_header_img img-fluid" :aria-label="healthplan.plantypename + ' Logo'"></div>-->
                            <div class="col-sm-6 text-right"><img :src="healthplan.carrier_logo" class="img-fluid" :aria-label="healthplan.plantypename + ' Logo'"></div>
                        </div>

                        <div class="row pt-2">
                            <div class="col-md-12 sb-benefit-list-title" v-if="healthplan.groupnum=='0300-V' || healthplan.groupnum=='0300-D'">Member SSN</div>
                            <div class="col-md-12 sb-benefit-list-title" v-else>{{healthplan.memberid}}</div>
                        </div>
                        <div class="row border-bottom pb-2">
                            <div class="col-md-12 sb-benefit-sublist-value">Member ID</div>
                        </div>

                        <div class="row  pt-2">
                            <div class="col-md-12 sb-benefit-list-title">{{healthplan.carrier}}</div>
                        </div>
                        <div class="row border-bottom pb-2">
                            <div class="col-md-12 sb-benefit-sublist-value">Carrier</div>
                        </div>

                        <div class="row  pt-2">
                            <div class="col-md-12 sb-benefit-list-title">{{healthplan.groupnum}}</div>
                        </div>
                        <div class="row border-bottom pb-2">
                            <div class="col-md-12 sb-benefit-sublist-value">Group Number</div>
                        </div>

                        <div class="row  pt-2">
                            <div class="col-md-12 sb-benefit-list-title">{{healthplan.planname + ' / ' + healthplan.plancode}}</div>
                        </div>
                        <div class="row border-bottom pb-2">
                            <div class="col-md-12 sb-benefit-sublist-value">Plan Name/ Plan Number</div>
                        </div>

                        <div v-for="f in getHpSummaryFields(healthplan.hpd_fields)">
                            <div class="row pt-2">
                                <div class="col-md-12 sb-benefit-list-title">
                                    {{f.type=='currency'?'$':''}}{{f.value==''?'&nbsp':f.value}}{{f.type=='percent'?'%':''}}
                                </div>
                            </div>
                            <div class="row border-bottom pb-2 m-0">
                                <div class="col-md-12 sb-benefit-sublist-value">
                                    {{f.label}}
                                </div>
                            </div>
                        </div>

                        <div class="row py-3">
                            <div class="col-md-12 text-center">
                                <a href="#" @click.prevent="openDetailedView(healthplan)" type="button" class="btn sb-btn-phr w-100">
                                    View Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
<!--            </div>-->
        </div>



        <div v-else>
            <div class="card" :style="'border: 1px solid ' + getColor(healthplanD.plantypename)">
                <div class="card-body benefit-card-body benefit-personal-card">
                    <div class="row" :style="'border-bottom: 1px solid ' + getColor(healthplanD.plantypename)">
                        <div class="col-md-5 benefits_header" :style="'color: ' + getColor(healthplanD.plantypename)">{{healthplanD.carrier + ' Contact Information'}}</div>
<!--                            <img :src="healthplanD.carrier_logo" class="mt-3 pl-4 mb-3 hp-logo"/>-->
                         <div class="col-md-7 text-right"><img v-if="healthplanD.carrier_logo" alt="HP Logo" :src="healthplanD.carrier_logo" class="hp-logo"/></div>
                    </div>

                    <div class="row benefit-personal-card__contact">
                        <div class="col-md-6 border-bottom">
                            <div class="row py-2 px-1">
                                <div class="col-md-6 font-weight-bold">{{healthplanD.carrier + ' Website'}}</div>
                                <div class="col-md-6 text-right">
                                    <a :href="getWebsite(healthplanD)" :title="healthplanD.carrier + ' Website'" class="sb-benefit-main-link pl-4 mb-3">
                                        <i class="bi bi-link-45deg"></i> {{getWebsite(healthplanD, true)}}
                                    </a>
                                    <div style="height:25px"></div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 border-bottom" v-for="(contact,key) in healthplanD.hpc" v-if="(contact.type=='phone' ||contact.type=='email') && (key<4 || showMore)">
<!--                            <div class="row py-2" :class="key % 2 === 0 && key !== 0 ? 'pr-3' : 'pl-3'">-->
                            <div class="row py-2 px-1">
                                <div class="col-sm-6 font-weight-bold">{{contact.title}}</div>
                                <div class="col-sm-6 text-right">
                                    <div>{{contact.phone}}</div>
                                    <div>Hours of Operation: 1-5</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="healthplanD.hpc.length>4">

                        <div v-show="!showMore"
                             class="col-md-12 text-center hide-or-show-button"
                             @click.prevent="showMore=!showMore">
                            <i class="fas fa-chevron-down"></i>
                        </div>
                        <div v-show="showMore"
                             class="col-md-12 text-center hide-or-show-button"
                             @click.prevent="showMore=!showMore">
                            <i class="fas fa-chevron-up"></i>
                        </div>
                    </div>
                </div>
            </div>



            <div v-for="field in healthplanD.hpd_fields" style="margin-top: 30px;">
                <div v-if="field.children.length>0" class="card" :style="'border: 1px solid ' + getColor(healthplanD.plantypename)">
                    <div class="card-body benefit-card-body benefit-card-body-row-wrapper">
                        <div class="row" :style="'border-bottom: 1px solid ' + getColor(healthplanD.plantypename)">
                            <div class="col-md-12 benefits_header" :style="'color: ' + getColor(healthplanD.plantypename)">{{field.label}}</div>
                        </div>
                        <div class="">
                            <div v-if="field.children.length > 0" v-for="subfield in field.children">
                                <div class="row py-2" :class="subfield.children.length > 0 ? '' : 'border-bottom'">
                                        <div class="col-md-6" :class="fieldClass(subfield.fieldtype)">
                                            {{subfield.label}}
                                        </div>
                                        <div class="col-md-6 text-right">
                                            {{subfield.type === 'currency' ? '$' : ''}}{{subfield.value}}{{subfield.type === 'percent' ? '%' : ''}}
                                        </div>
                                    </div>
                                <div  v-if="subfield.children.length > 0"
                                      v-for="sub in subfield.children"
                                     :class="{'three-level': subfield.children.length > 0 }"
                                >
                                    <div class="row py-2" :class="{'border-bottom': sub.children.length == 0}">
                                        <div class="col-md-6" :class="fieldClass(sub.fieldtype)">
                                            {{sub.label}}
                                        </div>
                                        <div class="col-md-6 text-right">
                                            {{sub.type === 'currency' ? '$' : ''}}{{sub.value}}{{sub.type === 'percent' ? '%' : ''}}
                                        </div>
                                    </div>

                                    <div class="benefit-indent"
                                         v-if="sub.children.length > 0"
                                         v-for="subsub in sub.children"
                                         :class="{'four-level' : subfield.children.length > 0}"
                                    >
                                            <div class="row  border-bottom">
                                                <div class="col-md-6" :class="fieldClass(subsub.fieldtype)">
                                                    {{subsub.label}}
                                                </div>
                                                <div class="col-md-6 text-right">
                                                    {{subsub.type == 'currency' ? '$' : ''}}{{subsub.value}}{{subsub.type == 'percent' ? '%' : ''}}
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="text-right mb-3 mr-3" v-if="false">
                            <a href="#">View Details</a>
                        </div>

                    </div>
                </div>
            </div>

            <div style="margin-top: 30px;">
                <div class="card" :style="'border: 1px solid ' + getColor(healthplanD.plantypename)">
                    <div class="card-body benefit-card-body benefit-card-body-row-wrapper">
                        <div class="row" :style="'border-bottom: 1px solid ' + getColor(healthplanD.plantypename)">
                            <div class="col-md-12 benefits_header" :style="'color: ' + getColor(healthplanD.plantypename)">NOTES</div>
                        </div>
                        <div class="mt-3">
                            <div v-if="healthplanD.note" class="w-95">
                                <div v-html="healthplanD.note" class="pb-2"></div>
                            </div>
                        </div>

                        <div class="text-right mb-3 mr-3" v-if="false">
                            <a href="#">View Details</a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<style>
    .mx-datepicker-popup{
        z-index: 10000;
    }
    .mx-datepicker{
        width: 100%;
    }
    .w-95 {
        width: 95%;
    }
</style>

<script>
    export default {
        name: 'SBHealthPlans',
        props:['healthplans'],
        data(){
            return {
                showMore:false,
                route: '/api/immunizations',
                list: true,
                showModal: false,
                im:{
                    id:'',
                    imm_imdid:'',
                    created_at:''
                },
                healthplanD:{},
                ims:[],
                view_more: false
            }
        },
        created() {
            if (this.$route.name === 'healthplans.detail') {
                const hp = this.healthplans.find(h => h.slug === this.$route.params.slug)

                this.openDetailedView(hp)
            }
            console.log(this.healthplanD)
        },
        methods:{
            getWebsite(healthplan, striphtml=false){
                if(striphtml)
                    return _.filter(healthplan.hpc,{type:"website"})[0]!== undefined?_.filter(healthplan.hpc,{type:"website"})[0].website.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0]:'';
                else
                    return _.filter(healthplan.hpc,{type:"website"})[0]!== undefined?_.filter(healthplan.hpc,{type:"website"})[0].website:''
            },
            getPhones(healthplan, half){
                let phones=[..._.filter(this.findFieldGroup(healthplan.hpd_fields[0].children,"contact"),{fieldtype:"phone"}).map(item=>{
                    return {
                        title: item.label,
                        phone: item.value
                    }
                }),...healthplan.hpc.map(item=>{
                    return {
                        title:item.title,
                        phone:item.phone
                    }
                })]
                if(half==1)
                    return phones.slice(0, Math.floor(phones.length / 2))
                else
                    return phones.slice(Math.floor(phones.length / 2), phones.length)

            },
            findFieldGroup(fields, fieldGroup){
                let data=[];
                _.forEach(fields, (value,key) => {
                    if(
                        value.fieldgroup==fieldGroup
                    ){
                        data.push(value);
                    }
                    if(value.children.length>0){
                        data=[...data, ...this.findFieldGroup(value.children, fieldGroup)];
                    }
                })
                return data;
            },
            openDetailedView(healthplan){
                this.healthplanD=healthplan
                this.list=false

                this.$router.push({ name: 'healthplans.detail', params: {slug: healthplan.slug} })
            },
            getHpSummaryFields(fields){
                let result = [];
                for (const field of fields) {
                    if ([1,3].includes(field.highlight)) result.push(field);
                    if (field.children.length > 0) result = result.concat(this.getHpSummaryFields(field.children));
                }
                return result;

            },
            firstTreeFields(fields){
                let data=[];
                _.forEach(fields, (value,key) => {
                    if(
                        // value.value!='' &&
                        value.children.length==0 &&
                        value.label!='Family' &&
                        value.label!='Individual' &&
                        value.fieldgroup!='contact'
                    ){
                        data.push(value);
                    }
                    if(value.children.length>0){
                        data=[...data, ...this.getFields(value.children)];
                    }
                })
                return _.take(data,3);
            },
            getFields(fields){
                let data=[];
                _.forEach(fields, (value,key) => {
                    if(
                        // value.value!='' &&
                        value.children.length==0 &&
                        value.label!='Family' &&
                        value.label!='Individual' &&
                        value.fieldgroup!='contact'
                    ){
                        data.push(value);
                    }
                    if(value.children.length>0){
                        data = [...data, ...this.getFields(value.children)];
                    }
                })
                return data;
            },
            outputDate(i){
                return moment(i.created_at).utc().format('MMMM DD, YYYY')
            },
            log(s){
                console.log(s)
            },
            addIm(){
                this.showModal=true;
                this.update=false
                this.im={
                    id:'',
                    imm_imdid:''
                };
            },
            saveIm(){

                this.$http.post(this.route, this.im)
                    .then(function(response) {
                        this.listIm();
                        this.$notify({
                            type:'success',
                            title: 'Success',
                            text: 'Immunization was created!'
                        });
                        this.showModal=false;
                    }, (response) => {
                        this._handleErrors(response.data, '#im-form')
                    })
            },
            listIm(){
                this.$http.get(this.route)
                    .then(function(response) {
                        this.ims=response.data;
                    }, (response) => {
                        this._handleErrors(response.data, '#im-form')
                    })
            },
            show(i){
                this.showModal=true;
                this.update=true
                this.im={
                    id:i.imm_id,
                    imm_imdid:{
                        imd_id:i.immunization_data.imd_id,
                        imd_name:i.immunization_data.imd_name
                    },
                    created_at:i.created_at
                };
            },
            updateIm(){
                this.$http.put(this.route, this.im)
                    .then(function(response) {
                        this.listIm();
                        this.$notify({
                            type:'success',
                            title: 'Success',
                            text: 'Immunization was updated!'
                        });
                        this.showModal=false;
                    }, (response) => {
                        this._handleErrors(response.data, '#im-form')
                    })
            },
            deleteIm(){
                this.$http.delete(this.route+'/'+this.im.id)
                    .then(function(response) {
                        this.listIm();
                        this.$notify({
                            type:'success',
                            title: 'Success',
                            text: 'Immunization was deleted!'
                        });
                        this.showModal=false;
                    }, (response) => {
                        this._handleErrors(response.data, '#im-form')
                    })
            },
            deleteImById(im){
                this.$http.delete(this.route+'/'+im.imm_id)
                    .then(function(response) {
                        this.listIm();
                        this.$notify({
                            type:'success',
                            title: 'Success',
                            text: 'Immunization was deleted!'
                        });
                        this.showModal=false;
                    }, (response) => {
                        this._handleErrors(response.data, '#im-form')
                    })
            },
            _handleErrors: function(items, selector)
            {
                $('.has-error').removeClass('has-error')
                $('.help-block').remove()

                for (var error in items['errors']) {
                    if (items['errors'].hasOwnProperty(error)) {
                        var text = error;
                        var parts = text.split('.');
                        var name = parts.pop();
                        var el = $(selector + ' [name="'+name+'"]')
                        el.closest('.form-group').addClass('has-error')
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            },
            fieldClass(fieldType) {
                if (!fieldType || fieldType === "") {
                    return "default-class";
                } else {
                    return fieldType;
                }
            },
            getColor(planTypeName) {
                if(planTypeName === 'Rx') {
                    return "#074864";
                }
                if(planTypeName === "Dental") {
                    return "#0E8278";
                }
                if(planTypeName === "Vision") {
                    return "#034641";
                }
                return "#0B82B4";
            },
            handleBackToBenefitsClick() {
                this.list = true
                this.$router.push({ name: 'healthplans' })
            }
        },
    }
</script>
